export { default } from '../[brandSlug]/videos/[id]';
